/**
 * Raw list of Curricular Competency Areas as they appear in the goal bank (XLSX / BC IEP data).
 * Use these exact strings when showing "Applicable Curricular Competency Area" and "Why chosen".
 */

// ELA (English Language Arts) — exact wording from data
export const ELA_AREAS = [
  "Curricular Competency Area: Comprehend and Connect (reading, listening, viewing) - Information Input",
  "Curricular Competency Area: Create and Communicate (writing, speaking, representing) - Information Ouput"
];

// Math (Numeracy) — exact wording from data
export const MATH_AREAS = [
  "Curricular Competency Area: Reasoning and Analyzing (estimate, mental math strategies, technology)",
  "Curricular Competency Area: Understanding and Solving",
  "Curricular Competency Area: Communicating and Representing (Note: Goals from this section should be worked on in conjunction with goals from the previous curricular competency areas (ie: understanding and solving)",
  "Curricular Competency Area: Connecting and Reflecting (for grades 7+)"
];

// Why chosen — mapping (for reference / UI)
export const AREA_WHY_CHOSEN = {
  ela: "Subject is ELA → Comprehend and Connect (Information Input) and Create and Communicate (Information Output) apply.",
  math_reasoning: "Subject is Math → Reasoning and Analyzing applies.",
  math_understanding: "Subject is Math → Understanding and Solving applies.",
  math_communicating: "Subject is Math → Communicating and Representing applies (with Understanding and Solving).",
  math_connecting: "Subject is Math and grade is 7+ → Connecting and Reflecting applies."
};

/** All areas in one list (raw strings only) */
export const ALL_AREAS_RAW = [...ELA_AREAS, ...MATH_AREAS];
